export function escapeHtml(str) {
  if (!str) return '';
  const buf = [];
  for (let i = str.length - 1; i >= 0; i--) {
    buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
  }
  return buf.join('');
}

/**
 * Converts an html characterSet into its original character.
 *
 * @param {String} str htmlSet entities
 **/
export function unescapeHtml(str) {
  return str.replace(/&#(\d+);/g, function(match, dec) {
    return String.fromCharCode(dec);
  });
}
